import { render } from "./AccessRightsHome.vue?vue&type=template&id=09205c81&scoped=true&ts=true&lang=pug"
import script from "./AccessRightsHome.vue?vue&type=script&lang=ts"
export * from "./AccessRightsHome.vue?vue&type=script&lang=ts"

import "./AccessRightsHome.vue?vue&type=style&index=0&id=09205c81&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09205c81"]])

export default __exports__